var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseActionLessonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#course_action_lesson_icon_svg__clip0_873_12134)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#course_action_lesson_icon_svg__clip1_873_12134)",
    stroke: "#3A3A3A",
    strokeWidth: 1.201,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.457 1.997H3.633a1.09 1.09 0 00-1.09 1.091v7.824c0 .602.488 1.09 1.09 1.09h7.824a1.09 1.09 0 001.09-1.09V3.088a1.09 1.09 0 00-1.09-1.09zM5.043 1.997v10.005M10.046 1.997v10.005M2.542 7h10.005M2.542 4.499h2.502M2.542 9.501h2.502M10.046 9.501h2.501M10.046 4.499h2.501"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "course_action_lesson_icon_svg__clip0_873_12134"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 7.773 7.773)",
    d: "M0 0h14v15.273H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "course_action_lesson_icon_svg__clip1_873_12134"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1.542 .997)",
    d: "M0 0h12.006v12.006H0z"
  })))));
}
export default SvgCourseActionLessonIcon;